(function () {
  'use strict';

  class MtReviewSlider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-mt-review-slider-track]');
      this.prevBtn = root.querySelector('[data-mt-review-slider-prev]');
      this.nextBtn = root.querySelector('[data-mt-review-slider-next]');
      this.progressBar = root.querySelector('[data-mt-review-slider-progress]');

      this.cards = this.track ? Array.from(this.track.children) : [];
      this.itemStep = 0;
      this.maxScroll = 0;
      this.destroyed = false;

      if (!this.track || this.cards.length < 2) {
        this.destroyed = true;
        return;
      }

      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      this.init();
    }

    init() {
      this.measure();
      this.updateUI();

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
    }

    measure() {
      if (!this.cards.length) return;
      const first = this.cards[0];
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      this.itemStep = first.getBoundingClientRect().width + gap;
      this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    scrollByStep(delta) {
      if (!this.itemStep) return;
      const target = this.track.scrollLeft + delta * this.itemStep;
      this.track.scrollTo({ left: target, behavior: 'smooth' });
    }

    onPrev() {
      if (this.prevBtn && this.prevBtn.classList.contains('is-disabled')) return;
      this.scrollByStep(-1);
    }

    onNext() {
      if (this.nextBtn && this.nextBtn.classList.contains('is-disabled')) return;
      this.scrollByStep(1);
    }

    onScroll() {
      this.updateUI();
    }

    onResize() {
      this.measure();
      this.updateUI();
    }

    updateUI() {
      const left = this.track.scrollLeft;
      const max = this.maxScroll || 0;
      const atStart = left <= 1;
      const atEnd = max <= 1 ? true : left >= max - 1;

      if (this.prevBtn) this.prevBtn.classList.toggle('is-disabled', atStart);
      if (this.nextBtn) this.nextBtn.classList.toggle('is-disabled', atEnd);

      if (this.progressBar) {
        const scrollRatio = max <= 0 ? 1 : Math.min(1, Math.max(0, left / max));
        const visibleRatio =
          this.track.scrollWidth > 0
            ? this.track.clientWidth / this.track.scrollWidth
            : 1;
        const cardMin = this.cards.length > 0 ? 100 / this.cards.length : 0.2;
        const minProgress = Math.min(
          100,
          Math.max(15, visibleRatio * 100, cardMin)
        );
        const progress = minProgress + scrollRatio * (100 - minProgress);
        this.progressBar.style.width = `${progress}%`;
      }
    }

    destroy() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.destroyed = true;
    }
  }

  const instances = new Map();

  function init(scope) {
    const root = scope || document;
    const nodes = root.querySelectorAll('[data-mt-review-slider]');
    nodes.forEach((node) => {
      if (instances.has(node)) return;
      const inst = new MtReviewSlider(node);
      if (!inst.destroyed) instances.set(node, inst);
    });
  }

  function destroy(scope) {
    const root = scope || document;
    const nodes = root.querySelectorAll('[data-mt-review-slider]');
    nodes.forEach((node) => {
      const inst = instances.get(node);
      if (!inst) return;
      inst.destroy();
      instances.delete(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroy(event.target);
  });
})();

